import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CartRoutingModule } from './cart-routing.module';
import { CartComponent } from './cart.component';
import { BackInStockComponent } from './components/back-in-stock/back-in-stock.component';
import { MyCartComponent } from './components/my-cart/my-cart.component';
import { OutOfStockComponent } from './components/out-of-stock/out-of-stock.component';
import { OrderDetailsComponent } from './components/order-details/order-details.component';
import { SharedModule } from '../shared/shared.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { NgxNumberSpinnerModule } from '../ngx-number-spinner/ngx-number-spinner.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { OrderConfirmationComponent } from './components/order-confirmation/order-confirmation.component';
import { NgSelectModule } from '@ng-select/ng-select';
import {NgcCookieConsentModule} from 'ngx-cookieconsent';
import { PaymentComponent } from './components/payment/payment.component';
import { MobilePaymentComponent } from './components/mobile-payment/mobile-payment.component';
import { PaymentSuccessComponent } from './components/payment-success/payment-success.component';
import { PaymentFailureComponent } from './components/payment-failure/payment-failure.component';
import { CardPaymentFailureComponent } from './components/card-payment-failure/card-payment-failure.component';
import { CardPaymentSuccessComponent } from './components/card-payment-success/card-payment-success.component';
import { ReviewComponent } from './components/review/review.component';
import { OrderSummaryComponent } from './components/order-summary/order-summary.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { RatingModule } from 'ngx-bootstrap/rating';
@NgModule({
  declarations: [CartComponent, BackInStockComponent, MyCartComponent, OutOfStockComponent,
  OrderDetailsComponent, OrderConfirmationComponent, PaymentComponent, MobilePaymentComponent, PaymentSuccessComponent, PaymentFailureComponent, CardPaymentFailureComponent, CardPaymentSuccessComponent, ReviewComponent, OrderSummaryComponent],
  imports: [
    CommonModule,
    CartRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    BsDropdownModule.forRoot(),
    SlickCarouselModule,
    CarouselModule.forRoot(),
    AccordionModule.forRoot(),
    NgxNumberSpinnerModule,
    InfiniteScrollModule,
    NgcCookieConsentModule,
    TooltipModule.forRoot(),
    RatingModule.forRoot()
 
  ]
})
export class CartModule { }
